import { combineEpics, type Epic } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { deleteEventMatchScoreEditRequest } from '@/api/events';
import i18n from '@/i18n';
import { deleteEventMatchScoreEdit, setCurrentMatchScore } from '../actions';

const deleteEventMatchScoreEditEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteEventMatchScoreEdit.match),
    request(
      ({ payload }) => deleteEventMatchScoreEditRequest(payload),
      deleteEventMatchScoreEdit,
    ),
  );

const deleteEventMatchScoreEditSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteEventMatchScoreEdit.succeeded.match),
    mergeMap(({ payload: { data } }) => [
      setCurrentMatchScore(data),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('DELETE_EVENT_MATCH_SCORE_EDIT_SUCCESS'),
      }),
    ]),
  );

export default combineEpics(
  deleteEventMatchScoreEditEpic,
  deleteEventMatchScoreEditSucceededEpic,
);
